<template>
    <div class="filters-container">
        <div class="filters-row">
            <!-- Filtro por Pilar -->
            <div class="filter-item">
                <b-form-select
                    id="filter-pillar"
                    v-model="localFilters.pillarId"
                    @change="emitFilters"
                    class="filter-select"
                >
                    <b-form-select-option :value="null">Todos los pilares</b-form-select-option>
                    <b-form-select-option
                        v-for="pillar in pillars"
                        :key="pillar.id"
                        :value="pillar.id"
                    >
                        {{ pillar.name }}
                    </b-form-select-option>
                </b-form-select>
            </div>

            <!-- Filtro por Elemento -->
            <div class="filter-item filter-item-grow">
                <b-form-select
                    id="filter-element"
                    v-model="localFilters.elementId"
                    @change="emitFilters"
                    :disabled="!localFilters.pillarId"
                    class="filter-select"
                >
                    <b-form-select-option :value="null">Todos los elementos</b-form-select-option>
                    <b-form-select-option
                        v-for="element in availableElements"
                        :key="element.id"
                        :value="element.id"
                    >
                        {{ element.name }}
                    </b-form-select-option>
                </b-form-select>
            </div>

            <!-- Filtro por Estado -->
            <div class="filter-item filter-item-small">
                <b-form-select
                    id="filter-status"
                    v-model="localFilters.status"
                    @change="emitFilters"
                    class="filter-select"
                >
                    <b-form-select-option :value="null">Todos los estados</b-form-select-option>
                    <b-form-select-option
                        v-for="status in statusDefinitions"
                        :key="status.value"
                        :value="status.value"
                    >
                        {{ status.label }}
                    </b-form-select-option>
                </b-form-select>
            </div>

            <!-- Filtro por Prioridad -->
            <div class="filter-item filter-item-small">
                <b-form-select
                    id="filter-priority"
                    v-model="localFilters.priority"
                    @change="emitFilters"
                    class="filter-select"
                >
                    <b-form-select-option :value="null">Todas las prioridades</b-form-select-option>
                    <b-form-select-option
                        v-for="priority in priorityDefinitions"
                        :key="priority.value"
                        :value="priority.value"
                    >
                        {{ priority.label }}
                    </b-form-select-option>
                </b-form-select>
            </div>

            <!-- Búsqueda -->
            <div class="filter-item filter-search">
                <div class="search-input-wrapper">
                    <b-form-input
                        id="filter-search"
                        v-model="localFilters.search"
                        placeholder="Buscar en ítems..."
                        @input="emitFilters"
                        class="search-input"
                    />
                    <button 
                        v-if="hasActiveFilters"
                        class="clear-btn"
                        @click="clearFilters"
                        title="Limpiar filtros"
                    >
                        <i class="fa fa-times"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ActionPlanFilters",
    props: {
        pillars: {
            type: Array,
            default: () => []
        },
        statusDefinitions: {
            type: Array,
            default: () => []
        },
        priorityDefinitions: {
            type: Array,
            default: () => [
                { value: 'Alto', label: 'Alto', color: '#DC2626' },
                { value: 'Medio', label: 'Medio', color: '#F59E0B' },
                { value: 'Bajo', label: 'Bajo', color: '#22C55E' }
            ]
        },
        value: {
            type: Object,
            default: () => ({
                pillarId: null,
                elementId: null,
                status: null,
                priority: null,
                search: ""
            })
        }
    },
    data() {
        return {
            localFilters: { ...this.value }
        };
    },
    computed: {
        availableElements() {
            if (!this.localFilters.pillarId) return [];
            
            const pillar = this.pillars.find(p => p.id === this.localFilters.pillarId);
            return pillar ? pillar.elements : [];
        },
        hasActiveFilters() {
            return this.localFilters.pillarId !== null ||
                   this.localFilters.elementId !== null ||
                   this.localFilters.status !== null ||
                   this.localFilters.priority !== null ||
                   (this.localFilters.search && this.localFilters.search.length > 0);
        }
    },
    watch: {
        value: {
            deep: true,
            handler(newVal) {
                this.localFilters = { ...newVal };
            }
        },
        'localFilters.pillarId'() {
            // Reset element filter when pillar changes
            this.localFilters.elementId = null;
        }
    },
    methods: {
        emitFilters() {
            this.$emit('input', { ...this.localFilters });
        },
        clearFilters() {
            this.localFilters = {
                pillarId: null,
                elementId: null,
                status: null,
                priority: null,
                search: ""
            };
            this.emitFilters();
        }
    }
};
</script>

<style scoped>
.filters-container {
    margin-bottom: 16px;
}

.filters-row {
    display: flex;
    gap: 12px;
    align-items: center;
    flex-wrap: wrap;
}

.filter-item {
    min-width: 180px;
}

.filter-item-small {
    min-width: 150px;
}

.filter-item-grow {
    flex: 1;
    min-width: 200px;
}

.filter-search {
    min-width: 180px;
}

.filter-select {
    border: 1px solid #E5E7EB;
    border-radius: 8px;
    padding: 8px 12px;
    font-size: 14px;
    color: #374151;
    background-color: #ffffff;
    height: auto;
}

.filter-select:focus {
    border-color: #10B981;
    box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);
}

.filter-select:disabled {
    background-color: #F9FAFB;
    color: #9CA3AF;
}

.search-input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
}

.search-input {
    border: 1px solid #E5E7EB;
    border-radius: 8px;
    padding: 8px 36px 8px 12px;
    font-size: 14px;
    width: 100%;
}

.search-input:focus {
    border-color: #10B981;
    box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);
}

.clear-btn {
    position: absolute;
    right: 8px;
    width: 24px;
    height: 24px;
    border: none;
    background: #F3F4F6;
    border-radius: 4px;
    color: #6B7280;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.15s ease;
}

.clear-btn:hover {
    background: #E5E7EB;
    color: #374151;
}

@media (max-width: 768px) {
    .filters-row {
        flex-direction: column;
    }
    
    .filter-item,
    .filter-item-grow,
    .filter-search {
        width: 100%;
        min-width: 100%;
    }
}
</style>